import { Component, OnInit, ɵConsole } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { PartnersService } from '../services/partners.service';

@Component({
  selector: 'app-managepartners',
  templateUrl: './managepartners.component.html',
  styleUrls: ['./managepartners.component.scss']
})
export class ManagepartnersComponent implements OnInit {


  public uploader: FileUploader = new FileUploader({});
  partnerForm:FormGroup;
  partnerFormUpdate:FormGroup;
  categoryList:any = [];
  partners
  isIncluded
  x = []
  selected = ''
  selectedCat:number

  modal: boolean;
  modalForm: FormGroup;
 
  updatedPartner:any = [];

  name = ""
  link= ""
 

  constructor(private partnersService: PartnersService,
    private formBuilder: FormBuilder) { }

  async ngOnInit() {
    this.partnerForm = this.formBuilder.group({
      name: '',
      url: '',
      // description: '',
      category: '',
      img: [null]
    });
    this.partnerFormUpdate = this.formBuilder.group({
      name: '',
      url: '',
      // description: '',
      category: '',
      img: [null]
    });
   await this.partnersService.getPartners().then((res:any) => {
      // console.log(res)
      this.partners = res.partners
      console.log("PARTNERS")
      console.log(this.partners)
    })
    await this.partnersService.getPartnersCategory().then((res:any)=> {
      // console.log(res)
      this.categoryList= res.partner_categories
      console.log("CATEGORIES")
      console.log(this.categoryList)
      const x: any[] = this.categoryList
    })
    
    this.getCategoriesId()
  }
  

  drop(event: CdkDragDrop<string[]>) {
    // let arrayLength = this.x.length
    // console.log(this.x.length)
    for (let i=0; i<this.x.length; i++){
      moveItemInArray(this.x[i].partners_list, event.previousIndex, event.currentIndex);
      console.log(event.previousIndex)
      console.log(event.currentIndex)
      this.partnersService.arrangePartner(event.previousIndex+1, event.currentIndex+1).then((res) => {
        console.log(res)
      })
    }
   
  }

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }
  url;
  msg = "";

  selectFile(event) {

    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg = "Only images are supported";
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.msg = "";
      this.url = reader.result;
    }

    const file = (event.target as HTMLInputElement).files[0];
    this.partnerForm.patchValue({
      img: file
    });

    this.partnerForm.get('img').updateValueAndValidity();
  }

  createPartner(){
    var formData: FormData = new FormData();
    console.log(this.partnerForm.get('img').value)
    formData.append("name", this.partnerForm.get('name').value);
    formData.append("partner_category_id", this.partnerForm.get('category').value);
    formData.append("description", this.partnerForm.get('description').value);
    formData.append("link", this.partnerForm.get('url').value);
    formData.append("image", this.partnerForm.get('img').value);

    this.partnersService.addPartner(formData).then((res:any)=> {
      if (res.success){
      console.log(res)
      this.partnerForm.reset()
      for (let i=0; i<this.partners.length; i++){
        this.partnersService.getPartners().then((res:any) => {
          // console.log(res)
          this.partners = res.partners
          this.getCategoriesId()
        })
      }
    }
    })
  }
  

  getCategoriesId(){
   

    // let x = []
      
      
      for(let i=0;i<this.categoryList.length;i++){
        for(let j=0;j<this.partners.length;j++){
          if(this.categoryList[i].id == this.partners[j].partner_category_id){
            const found = this.x.some(el => el.category_id === this.categoryList[i].id)
          if(!found){
           
            // console.log("not included")
            // console.log(this.categoryList[i].id)
            this.x.push({
              category_name: this.categoryList[i].name,
              category_id: this.categoryList[i].id,
              partners_list:[ this.partners[j]]
            })
          } else{
            // console.log("included")
            // console.log(this.categoryList[i].id)
            for(let a=0;a<this.x.length;a++){
              if(this.x[a].category_id == this.categoryList[i].id){

                this.x[a].partners_list.push(this.partners[j])
              }
            }
    
          }
          
        }
        }
      
      }
      console.log(this.x)
  }

  deletePartner(id){
    console.log(id)
    this.partnersService.deletePartner(id).then((res)=>{
      console.log(res)
    })
  }

  // updateCategory(id){
  //   console.log(id)
  // }

  showCancellation(info) {
    this.modal = true;
    this.updatedPartner = info;
    console.log(this.updatedPartner)
    this.selectedCat = this.updatedPartner.partner_category_id
    // this.selectedCat = 1
    // this.selected=this.updatedPartner.partner_category_id
    this.partnerFormUpdate = this.formBuilder.group({
      name: this.updatedPartner.name,
      url: this.updatedPartner.link,
      // description: '',
      category: this.updatedPartner.partner_category_id,
      img: [this.updatedPartner.image]
    });
    
    // this.modal = true;
    // this.updatedPartner = info;
    // this.name = this.updatedPartner.name
    // this.link = this.updatedPartner.link
    // console.log(this.updatedPartner)
    // console.log("NAME ON OPEN MODAL:  ", this.name)
    // console.log("DESC ON OPEN MODAL:  ", this.link)
    console.log(this.partnerFormUpdate.get('name').value)
  }

  hideCancellation() {
    this.modal = false;
  }

  update(){
    console.log(this.partnerFormUpdate.get('category').value)
    console.log("TEST,  "+ this.updatedPartner.id)
    // console.log(this.name, this.link)
    var formData: FormData = new FormData();

    formData.append("name", this.partnerFormUpdate.get('name').value);
    formData.append("description", this.partnerFormUpdate.get('name').value);
    formData.append("link", this.partnerFormUpdate.get('url').value);
    formData.append("partner_category_id", this.partnerFormUpdate.get('category').value);
    formData.append("image", this.partnerFormUpdate.get('img').value);
    // formData.append("organizer_email", this.eventDetails.organizer_email);
    // formData.append("category", selectedCategories+'');

    // console.log("NAME ON UPDATE:  ", this.name)
    // console.log("DESC ON UPDATE:  ", this.link)
    // if (this.name == ""){ this.name = this.updatedPartner.name; console.log("REPLACED NAME BY:  ", this.updatedPartner.name)}
    // if (this.link == ""){ this.link = this.updatedPartner.link; console.log("REPLACED DESC BY:  ", this.updatedPartner.link)}
    // // console.log("MODIFIED NAME", this.updatedPartner.name)
    // // console.log("MODIFIED DESC", this.updatedPartner.link)
    // console.log("NAME SENT:  ", this.name)
    // console.log("DESC SENT:  ", this.link)
    // // console.log(this.name)
    // // console.log(this.link)
    this.partnersService.updatePartner(this.updatedPartner.id, formData).then((res:any) => {

      console.log(res)
      // this.modal = false;
      // for (let i=0; i<this.categoryList.length; i++){
      //   if(this.categoryList[i].id == this.updatedPartner.id){
      //     this.categoryList[i].name = this.name;
      //     this.categoryList[i].link = this.link;
      //   }
      // }
    })
    // this.name = this.updatedPartner.name
    // this.description = this.updatedPartner.description
  }

}
